import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { connect } from 'react-redux'
import { withRouter } from 'next/router'
import { compose, branch, renderNothing, renderComponent } from 'recompose'

const BackUrl = ({ router }) => {
  const { t } = useTranslation('common')

  return (
    <a href="javascript:void(0)" onClick={() => router.back()}>
      <i className='ico-nazad ico' />
      <p>{t('Nazad')}</p>
    </a>
  )
}

BackUrl.propTypes = {
  router: PropTypes.shape({
    back: PropTypes.func
  }).isRequired
}

export default withRouter(BackUrl)
